import { t } from '@alternativamais/chat-core';
import { useEffect, useState } from 'react';

import { Icone } from '../../componentes/Icone';
import { useCliente, useEstadoRaso } from '../../chat/contexto';

/**
 * Faixa no alto quando o gateway cai (C52): tentando de novo, com contagem
 * e "Reconectar agora". Versão antiga (4012): pede para recarregar.
 */
export function AvisoConexao() {
  const cliente = useCliente();
  const conexao = useEstadoRaso((estado) => estado.connection);
  const caiu = conexao.status !== 'ready' && conexao.status !== 'disconnected';
  const [mostrar, setMostrar] = useState(false);
  const [restante, setRestante] = useState<number | null>(null);

  // Espera 1,5 s antes de mostrar (uma retomada rápida não pisca a faixa).
  useEffect(() => {
    if (!caiu) return;
    const espera = window.setTimeout(() => setMostrar(true), 1_500);
    return () => {
      window.clearTimeout(espera);
      setMostrar(false);
    };
  }, [caiu]);

  // Contagem até a próxima tentativa.
  const { retryInMs, status } = conexao;
  useEffect(() => {
    if (retryInMs === null) return;
    const proxima = Date.now() + retryInMs;
    const contar = () =>
      setRestante(Math.max(0, Math.ceil((proxima - Date.now()) / 1000)));
    const id = window.setInterval(contar, 250);
    const primeira = window.setTimeout(contar, 0);
    return () => {
      window.clearInterval(id);
      window.clearTimeout(primeira);
      setRestante(null);
    };
  }, [retryInMs, status]);

  if (conexao.fatalCode === 4012) {
    return (
      <Faixa
        texto={t('conexao.versaoAntiga')}
        botao="Recarregar"
        aoClicar={() => window.location.reload()}
      />
    );
  }
  if (!caiu || !mostrar) return null;
  const texto =
    status === 'reconnecting' && restante !== null
      ? `Conexão perdida. Tentando de novo em ${restante} s…`
      : 'Conexão perdida. Reconectando…';
  return (
    <Faixa
      texto={texto}
      botao="Reconectar agora"
      aoClicar={() => cliente.reconnectNow()}
    />
  );
}

function Faixa({
  texto,
  botao,
  aoClicar,
}: {
  texto: string;
  botao: string;
  aoClicar: () => void;
}) {
  return (
    <div
      role="alert"
      className="flex h-9 shrink-0 items-center gap-2.5 bg-ausente pr-2 pl-4 text-[13px] font-semibold text-destaque-texto"
    >
      <Icone nome="alerta" tamanho={18} />
      <span className="min-w-0 grow truncate">{texto}</span>
      <button
        type="button"
        onClick={aoClicar}
        className="h-6 shrink-0 rounded-md bg-black/10 px-2.5 font-semibold hover:bg-black/20"
      >
        {botao}
      </button>
    </div>
  );
}
